import React from 'react';
import contentBar from '../../assets/contentBar.svg';
import { Button, Divider } from 'br2s-ui-componentlibrary_r2_02';
import { SystemIcon } from 'br2s-ui-componentlibrary_r2_02/dist/foundation/assets/system-icon';

type InstructionWrapperProps = {
  id: string;
  children: React.ReactNode;
  onTransactionStart: () => void;
};

const InstructionWrapper = ({
  id,
  children,
  onTransactionStart,
}: InstructionWrapperProps) => (
  <div id={id}>
    <div id="instruction-container" className="cmn-instruction-wrapper">
      <div className="container">
        <div className="row g-0">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <img
              src={contentBar}
              alt="content-bar"
              id="content-bar"
              className="instruction-cover-img"
            />
          </div>
        </div>
        <div className="row g-0">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div className="instruction-content-body">
              <div className="instruction-magnolia-container">{children}</div>
              <div className="row g-0 instruction-bottom-divider">
                <Divider id="information-snippet-divider" />
              </div>
              <div className="row g-0">
                <div className="instruction-button-container">
                  <Button
                    id="instruction-start-app-btn"
                    type="primary"
                    label="Start"
                    size="large"
                    iconType="appended"
                    iconClassName={SystemIcon.NavigationArrowForward}
                    onClick={onTransactionStart}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default InstructionWrapper;
